import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { AdminGetCompiledProviderDepartmentOptionQueryDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminGetCompiledProviderDepartmentOptionQueryResultFragment, AdminGetCompiledProviderDepartmentOptionQueryParams } from '@docpace/admin-graphql'

export const typedAdminGetCompiledProviderDepartmentOptionQueryDocument = AdminGetCompiledProviderDepartmentOptionQueryDocument as TypedDocumentNode<AdminGetCompiledProviderDepartmentOptionQueryResultFragment, Partial<AdminGetCompiledProviderDepartmentOptionQueryParams>>

export function useAdminGetCompiledProviderDepartmentOptionQuery(opts?: useQuery.Options<AdminGetCompiledProviderDepartmentOptionQueryResultFragment, Partial<AdminGetCompiledProviderDepartmentOptionQueryParams>>){
    return useQuery(typedAdminGetCompiledProviderDepartmentOptionQueryDocument, opts)
}
